import React, { useRef, useState } from 'react'
import { savePortalSignature, applyPortalSign } from './portalApi'
import { btn, font, dark } from './portalStyles'
import { translations } from './portalI18n'

const PortalSignModal = ({ task, onSigned, onClose, lang = 'es' }) => {
    const t = translations[lang]
    const canvasRef = useRef(null)
    const [isDrawing, setIsDrawing] = useState(false)
    const [lastPos, setLastPos] = useState(null)
    const [isEmpty, setIsEmpty] = useState(true)
    const [saving, setSaving] = useState(false)

    const getPos = (e) => {
        const canvas = canvasRef.current
        const rect = canvas.getBoundingClientRect()
        const clientX = e.touches ? e.touches[0].clientX : e.clientX
        const clientY = e.touches ? e.touches[0].clientY : e.clientY
        return {
            x: (clientX - rect.left) * (canvas.width / rect.width),
            y: (clientY - rect.top) * (canvas.height / rect.height),
        }
    }

    const startDrawing = (e) => {
        e.preventDefault()
        setIsDrawing(true)
        setLastPos(getPos(e))
        setIsEmpty(false)
    }

    const draw = (e) => {
        e.preventDefault()
        if (!isDrawing) return
        const canvas = canvasRef.current
        const ctx = canvas.getContext('2d')
        const pos = getPos(e)
        ctx.beginPath()
        ctx.moveTo(lastPos.x, lastPos.y)
        ctx.lineTo(pos.x, pos.y)
        ctx.strokeStyle = '#f0f0f0'
        ctx.lineWidth = 2
        ctx.lineCap = 'round'
        ctx.lineJoin = 'round'
        ctx.stroke()
        setLastPos(pos)
    }

    const stopDrawing = () => setIsDrawing(false)

    const clear = () => {
        const canvas = canvasRef.current
        const ctx = canvas.getContext('2d')
        ctx.clearRect(0, 0, canvas.width, canvas.height)
        setIsEmpty(true)
    }

    const save = async () => {
        if (isEmpty) return
        setSaving(true)
        try {
            const dataUrl = canvasRef.current.toDataURL('image/png')
            const url = await savePortalSignature(task.id, dataUrl)
            await applyPortalSign(task.id, url)
            onSigned()
        } catch (err) {
            console.error('Error al guardar firma', err)
            setSaving(false)
        }
    }

    return (
        <div style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.75)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 1000, padding: '20px', fontFamily: font,
        }}>
            <div style={{
                background: dark.surface,
                border: `1px solid ${dark.border}`,
                borderRadius: '12px',
                padding: '28px', width: '100%', maxWidth: '520px',
            }}>
                <h2 style={{ margin: '0 0 4px', fontSize: '18px', color: dark.text }}>
                    {t.signTitle}
                </h2>
                <p style={{ margin: '0 0 20px', color: dark.text2, fontSize: '14px' }}>
                    Ref. {task.reference} — {task.deviceName} — {task.budget} €
                </p>

                <div style={{ background: dark.surface2, borderRadius: '8px', border: `1px solid ${dark.border}`, marginBottom: '8px' }}>
                    <canvas
                        ref={canvasRef}
                        width={800}
                        height={200}
                        style={{ width: '100%', display: 'block', touchAction: 'none', cursor: 'crosshair', borderRadius: '8px' }}
                        onMouseDown={startDrawing}
                        onMouseMove={draw}
                        onMouseUp={stopDrawing}
                        onMouseLeave={stopDrawing}
                        onTouchStart={startDrawing}
                        onTouchMove={draw}
                        onTouchEnd={stopDrawing}
                    />
                </div>

                <p style={{ margin: '0 0 20px', color: dark.text3, fontSize: '12px', textAlign: 'center' }}>
                    {t.signHint}
                </p>

                <p style={{ margin: '0 0 20px', fontSize: '12px', color: dark.text2, lineHeight: '1.5' }}>
                    {t.signLegal(task.budget, task.deviceName, task.description)}
                </p>

                <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', flexWrap: 'wrap' }}>
                    <button onClick={clear} style={btn.ghost}>{t.clear}</button>
                    <button onClick={onClose} style={btn.outline}>{t.cancel}</button>
                    <button
                        onClick={save}
                        disabled={isEmpty || saving}
                        style={{ ...btn.primary, opacity: (isEmpty || saving) ? 0.4 : 1 }}
                    >
                        {saving ? t.saving : t.confirmSign}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default PortalSignModal
